import { ComboBox, FontIcon, IComboBox, IComboBoxOption, PanelType, TextField } from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import { IIpercEquipos, IPOSTActividad } from "../../../Interfaces/IIpercBase";
import { IHeaderTitlesText } from "../../../Interfaces/IPanel";
import { useBoolean } from "@fluentui/react-hooks";
import IPERCService from "../../../services/IPERCService";
import COLORES from "../../../utils/theme/colores";
import HelpersIpercBase from "../../../utils/helpers/HelpersIpercBase";

interface INuevoProceso {
    setup: () => void
    isOpen: boolean
    onDismiss: ((ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => void)
}

const HeaderPanelTiles: IHeaderTitlesText = {
    title: 'Nueva Actividad',
    subTitle: 'Complete los campos para registar Actividad',
}

function NuevaActividad(props: INuevoProceso) {
    const [equipos, setEquipos] = useState<IComboBoxOption[]>([]);
    const [model, setModel] = useState<IPOSTActividad | undefined>(undefined);
    const [isComplete, { setTrue: enabledR, setFalse: disabledR }] = useBoolean(false);
    const dataEquipos = useCallback((filter?: string) => {
        setEquipos([])
        IPERCService.ListaEquipos().then((res) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            let d: IIpercEquipos[] = res.data
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            let o: IComboBoxOption[] = []
            // eslint-disable-next-line array-callback-return
            d.map((arg: IIpercEquipos) => {
                o.push({
                    key: arg.equipoId,
                    text: arg.nombre
                })
            })
            setEquipos(o)
        }).catch((e: Error) => {
            alert(e.message)
        })
    }, [])

    useEffect(() => {
        setModel(undefined)
        dataEquipos()
    }, []);

    const _handleChange = (
        { target }: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ) => {
        // const { name, value } = target as HTMLInputElement;
        if (newValue)
            setModel({ ...model, nombre: newValue })
    };

    const _onchangeOption = (
        event: React.FormEvent<IComboBox>, option?: IComboBoxOption | undefined,
        index?: number | undefined,
        value?: string | undefined) => {
        if (option?.key) {
            setModel({ ...model, equipoId: option.key.toString() })
        }
    }

    useEffect(() => {
        if (model != undefined) {
            disabledR()
        } else {
            enabledR()
        }
    }, [model]);

    const _registar = () => {
        if (model)
            IPERCService.CrearActividad(model).then((res) => {
                console.log(res.statusText)
                props.onDismiss()
                props.setup()
            }).catch((e: Error) => {
                alert(e.message)
            })
    }

    return (
        <PanelGenerico
            isOpen={props.isOpen}
            onDismiss={props.onDismiss}
            disabledRegister={isComplete}
            enabledHeader
            HeaderTitlesText={HeaderPanelTiles}
            iconHeaderName='ProcessMetaTask'
            enabledIconHeader={false}
            objectRenderBodyHelp={model}
            registrar={_registar}
            cancelar={props.onDismiss}
        // panelType={PanelType.smallFixedFar}
        >
            <br />
            <br />
            <div className="ms-Grid-col ms-lg12">
                <br />
                <TextField
                    {...HelpersIpercBase.TextTextFieldElevation}
                    onChange={_handleChange}
                    onRenderPrefix={(arg) => (<FontIcon iconName="Rename" style={{ color: COLORES.Bases.primary }} />)}
                    placeholder="Nombre de actividad *"
                />
            </div>
            <br />
            <div className="ms-Grid-col ms-lg12">
                <ComboBox
                    // componentRef={comboBoxRef}
                    useComboBoxAsMenuWidth
                    allowFreeform
                    calloutProps={{ directionalHintFixed: true }}
                    scrollSelectedToTop
                    autoComplete="off"
                    label="Equipo *"
                    // placeholder="Equipo *"
                    options={equipos}
                    onChange={_onchangeOption}
                />
            </div>
        </PanelGenerico>
    );
}

export default NuevaActividad;

